// ======================================================================
// File Name       : UserHistoryStudentDetailContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { Modal, Form, Col, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as UserHistoryStudentAction from '../../../actions/UserHistoryStudentAction';
import UserHistoryStudentDetailTitle from '../../../components/userHistory/student/UserHistoryStudentDetailTitle';
import UserHistoryStudentDetailCourseTitle from '../../../components/userHistory/student/UserHistoryStudentDetailCourseTitle';
import UserHistoryStudentDetailCourseList from '../../../components/userHistory/student/UserHistoryStudentDetailCourseList';
import { convertObjectToList } from '../../../utils/UserUtils';
import { RETURN_MAX_NUM, SELECT_TARGET_DATA } from '../../../constants/index';
import DialogConfirm from '../../../components/DialogConfirm';
import * as MessageTemplate from '../../../constants/MessageTemplate';
import { showExportCSVSuccessMessage } from '../../../utils/index';
import Header from '../../../components/Header';
import {
  USER_HISTORY_STUDENT_RESULT,
  USER_HISTORY_STUDENT_DETAIL,
  USER_HISTORY_COURSE_STUDENT_RESULT,
  USER_HISTORY_COURSE_STUDENT_DETAIL,
  USER_HISTORY_STUDENT_LIST,
  USER_HISTORY_COURSE_LIST,
  USER_HISTORY_COURSE_DETAIL,
  USER_HISTORY_COURSE,
} from '../../../constants/PathConstants';
import course from '../../../reducers/enterprise';
import * as actionType from '../../../constants/actionTypes/page';
import CustomLink from '../../../components/button/CustomLink';

class UserHistoryStudentDetailContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userSecernId: null,
      startPosition: 0,
      returnMaxNum: RETURN_MAX_NUM,
      showModalConfirm: false,
      typeModalConfirm: null,
      learningHistorySortType: null,
      ascendingDescendingSort: null,
    };
    this.handleSortState = this.handleSortState.bind(this);
    this.handleGetStartEndData = this.handleGetStartEndData.bind(this);
    this.onConfirmDialogCancelBtnClick = this.onConfirmDialogCancelBtnClick.bind(this);
    this.onConfirmDialogOkBtnClick = this.onConfirmDialogOkBtnClick.bind(this);
    this.getUserHistoryStudentDetail = this.getUserHistoryStudentDetail.bind(this);
    this.handleChangeCourse = this.handleChangeCourse.bind(this);
    this.goBack = this.goBack.bind(this);
    this.goToDetail = this.goToDetail.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this)
  }

  componentWillMount() {
    const { match, initialValues, userList } = this.props;
    if (match.params.id) {
      let initCourseSecernId = null;
      if (initialValues && initialValues.courseSecernId) {
        initCourseSecernId = initialValues.courseSecernId;
      }
      let startPosition = 0;
      if (initialValues && initialValues.startPosition) {
        startPosition = initialValues.startPosition;
      }
      let learningHistorySortType = null;
      if (initialValues && initialValues.learningHistorySortType) {
        learningHistorySortType = initialValues.learningHistorySortType;
      }
      if (!userList || !userList.length || (userList[0].userSecernId !== match.params.id)) {
        this.props
          .dispatch(UserHistoryStudentAction.initUserHistoryDetail(match.params.id))
          .then(() => {
            this.getCourseByUserList(match.params.id, initCourseSecernId, startPosition, learningHistorySortType);
          });
      } else {
        this.getCourseByUserList(match.params.id, initCourseSecernId, startPosition, learningHistorySortType);
      }
      this.setState({ userSecernId: match.params.id });
    }
  }

  componentWillUnmount() {
    this.props.dispatch(UserHistoryStudentAction.resetCourseStatusList());
    this.props.dispatch({
      type: 'RESET_HISTORY_COURSE_DETAIL',
    });
  }

  getCourseByUserList(userSecernId, initCourseSecernId, startPosition, column) {
    if (userSecernId) {
      const {
        returnMaxNum,
      } = this.state;
      const userList = [];
      let learningHistorySortType = null;
      let ascendingDescendingSort = null;
      if (column && Object.keys(column).length) {
        ascendingDescendingSort = column.sortState;
        learningHistorySortType = column.sortBy;
      }
      if (!column) {
        ascendingDescendingSort = null;
        learningHistorySortType = null;
      }
      userList.push(userSecernId);
      this.props.dispatch(
        UserHistoryStudentAction.getCourseByUserList(
          userList,
          true, // isUserHistoryDetail
          startPosition,
          returnMaxNum,
          learningHistorySortType,
          ascendingDescendingSort,
          SELECT_TARGET_DATA.DATA,
          initCourseSecernId,
        ),
      );
      this.setState({
        userSecernId,
      });
    }
  }

  getUserHistoryStudentDetail(courseSecernId, startPosition, column) {
    const {
      userSecernId,
      returnMaxNum,
    } = this.state;
    const { formValues } = this.props;
    let learningHistorySortType = null;
    let ascendingDescendingSort = null;
    if (column && Object.keys(column).length) {
      ascendingDescendingSort = column.sortState;
      learningHistorySortType = column.sortBy;
    }
    if (!column) {
      ascendingDescendingSort = null;
      learningHistorySortType = null;
    }
    if (userSecernId) {
      const userList = [userSecernId];
      const courseList = [courseSecernId];
      this.props.dispatch(
        UserHistoryStudentAction.getHistoryListBySearch(
          userList,
          courseList,
          startPosition,
          returnMaxNum,
          learningHistorySortType,
          ascendingDescendingSort,
          SELECT_TARGET_DATA.DATA,
        ),
      );
    }
  }

  handleChangeCourse(courseSecernId) {
    const learningHistorySortType = { index: 0, isSort: true, sortState: null, title: 'コンテンツ種別', sortBy: null };
    this.props.change('startPosition', 0);
    this.getUserHistoryStudentDetail(courseSecernId, 0, learningHistorySortType);
  }

  handleGetStartEndData(startPosition) {
    const { invalid, formValues, courseSecernId } = this.props;
    if (invalid) return;
    const column = formValues.learningHistorySortType;
    if (courseSecernId) {
      this.getUserHistoryStudentDetail(courseSecernId, startPosition, column);
    }
  }

  handleSortState(column) {
    const { invalid, courseSecernId, formValues } = this.props;
    if (invalid) return;
    let startPosition = 0;
    if (formValues && formValues.startPosition) {
      startPosition = formValues.startPosition;
    }
    if (courseSecernId) {
      this.getUserHistoryStudentDetail(courseSecernId, startPosition, column);
    }
  }

  openConfirmDialog(mdContent, type) {
    this.content = mdContent;
    this.setState({ showModalConfirm: true, typeModalConfirm: type });
  }

  onConfirmDialogCancelBtnClick() {
    this.setState({ showModalConfirm: false, typeModalConfirm: null });
  }

  onConfirmDialogOkBtnClick() {
    this.setState({ showModalConfirm: false, typeModalConfirm: null });
    const {
      typeModalConfirm,
      userSecernId,
      startPosition,
      returnMaxNum,
      ascendingDescendingSort,
      learningHistorySortType,
    } = this.state;
    const { courseSecernId } = this.props.userHistoryStudentDetail.values;
    if (typeModalConfirm === 'User') {
      // fix #5932: add current courses of student into params
      const { courseStatusList } = this.props;
      const courseList = [];
      if (courseStatusList && courseStatusList.length > 0) {
        courseStatusList.forEach((value) => {
          if (value.courseSecernId) {
            courseList.push(value.courseSecernId);
          }
        });
      }
      this.props
        .dispatch(
          UserHistoryStudentAction.getHistoryListBySearch(
            [userSecernId],
            courseList,
            startPosition,
            returnMaxNum,
            learningHistorySortType,
            ascendingDescendingSort,
            SELECT_TARGET_DATA.CSV,
          ),
        )
        .then(() => {
          showExportCSVSuccessMessage();
        });
    } else {
      this.props
        .dispatch(
          UserHistoryStudentAction.getHistoryListBySearch(
            [userSecernId],
            [courseSecernId],
            startPosition,
            returnMaxNum,
            learningHistorySortType,
            ascendingDescendingSort,
            SELECT_TARGET_DATA.CSV,
          ),
        )
        .then(() => {
          showExportCSVSuccessMessage();
        });
    }
  }

  goBack() {
    // Step 9.0.0 START
    const { match } = this.props;
    if (match && match.path.indexOf(USER_HISTORY_COURSE) > -1) {
      this.props.history.goBack();  
    }
    // Step 9.0.0 END
    this.props.history.goBack();
  }

  goToDetail(historyHash) {
    if (!historyHash) return;
    const { formValues, match } = this.props;
    if (match && match.path && match.path === USER_HISTORY_STUDENT_DETAIL) {
      const path = USER_HISTORY_STUDENT_RESULT.replace(':id', historyHash);
      this.props.dispatch({
        type: actionType.SAVE_SEARCH_CONDITION_SUB,
        parentPathSub: USER_HISTORY_STUDENT_DETAIL,
        searchConditionSub: formValues,
      });
      this.props.history.push(path);
    }
    if (match && match.path && match.path === USER_HISTORY_COURSE_STUDENT_DETAIL) {
      const path = USER_HISTORY_COURSE_STUDENT_RESULT.replace(':id', historyHash);
      this.props.dispatch({
        type: actionType.SAVE_SEARCH_CONDITION_SUB,
        parentPathSub: USER_HISTORY_COURSE_STUDENT_DETAIL,
        searchConditionSub: formValues,
      });
      this.props.history.push(path);
    }
  }
  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }


  render() {
    const {
      userList,
      groupList,
      groupRelationList,
      courseStatusList,
      learningHistoryList,
      recordNum,
      contentList,
      itemList,
      formValues,
    } = this.props;
    const {
      userSecernId,
      learningHistorySortType,
      ascendingDescendingSort,
    } = this.state;
    let startPosition = 0;
    if (formValues && formValues.startPosition) {
      startPosition = formValues.startPosition;
    }
    const { hoverIndex } = this.state;
    const { parentPath, courseSecernId, match } = this.props;
    let goBackText = match.path.indexOf(USER_HISTORY_COURSE) > -1 ? "戻る" : "学習履歴一覧に戻る";

    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          onClick={this.goBack} // Step 9.0.0
          text={goBackText}
          icon="bi bi-chevron-left"
        />
        <Header name="ユーザー別履歴情報の詳細" />
        <UserHistoryStudentDetailTitle
          groupList={groupList}
          userList={userList}
          groupRelationList={groupRelationList}
          userSecernId={userSecernId}
          onExportFileCSV={this.openConfirmDialog.bind(this, MessageTemplate.BULK_EXPORT, 'User')}
        />
        <UserHistoryStudentDetailCourseTitle
          {...this.props}
          groupList={groupList}
          userList={userList}
          courseStatusList={courseStatusList}
          learningHistoryList={learningHistoryList}
          userSecernId={userSecernId}
          learningHistorySortType={learningHistorySortType}
          ascendingDescendingSort={ascendingDescendingSort}
          recordNum={recordNum}
          getStartEndData={this.handleGetStartEndData}
          handleChangeCourse={this.handleChangeCourse}
          onExportFileCSV={this.openConfirmDialog.bind(this, MessageTemplate.BULK_EXPORT, 'Course')}
        />
        <UserHistoryStudentDetailCourseList
          {...this.props}
          userSecernId={userSecernId}
          contentList={contentList}
          handleSortState={this.handleSortState}
          learningHistoryList={learningHistoryList}
          itemList={itemList}
          goBack={this.goBack}
          goToDetail={this.goToDetail}
          dataSort={this.state}
          recordNum={recordNum}
          getStartEndData={this.handleGetStartEndData}
          hoverIndex={hoverIndex}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
        />
        <DialogConfirm
          showModal={this.state.showModalConfirm}
          onCancel={this.onConfirmDialogCancelBtnClick}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onConfirmDialogOkBtnClick}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { parentPath, parentPathSub, searchConditionSub } = state.page;
  const { userHistoryStudent, userSecernId } = state;
  const { userHistoryData, userHistoryDetailData, courseDetail } = userHistoryStudent;
  const { userHistoryStudentDetail } = state.form;
  const { groupList, groupRelationList, userList, courseStatusList } = userHistoryData;
  const { learningHistoryList, recordNum, contentList, itemList } = userHistoryDetailData;
  const formValues = getFormValues('userHistoryStudentDetail')(state);
  let courseSecernId = null;
  if (userHistoryStudentDetail && userHistoryStudentDetail.values) {
    courseSecernId = userHistoryStudentDetail.values.courseSecernId;
  }
  const data = {
    courseSecernId:
      courseStatusList && courseStatusList[0] && courseStatusList[0].courseSecernId
        ? courseStatusList[0].courseSecernId
        : null,
    startPosition: 0,
    learningHistorySortType: null,
    ascendingDescendingSort: null,
  };
  if (courseDetail && courseDetail.courseSecernId) {
    data.courseSecernId = courseDetail.courseSecernId;
  }
  if (
    parentPathSub === USER_HISTORY_STUDENT_DETAIL ||
    parentPathSub === USER_HISTORY_COURSE_STUDENT_DETAIL
  ) {
    if (searchConditionSub && searchConditionSub.courseSecernId) {
      data.courseSecernId = searchConditionSub.courseSecernId;
      data.startPosition = searchConditionSub.startPosition;
      data.learningHistorySortType = searchConditionSub.learningHistorySortType;
    }
  }
  return {
    ...{
      userHistoryData,
      userHistoryStudent,
      groupList,
      groupRelationList,
      recordNum,
      userList,
      courseStatusList,
      userHistoryStudentDetail,
      learningHistoryList,
      contentList,
      courseSecernId,
      itemList,
      formValues,
      parentPath,
    },
    initialValues: data,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'userHistoryStudentDetail', // a unique identifier for this form
    enableReinitialize: true,
    touchOnChange: true,
  })(UserHistoryStudentDetailContainer),
);
